export const LESCAPES_SIGNUP_DOMAIN = 'Luxury Escapes'

export const APPLE_PRIVATE_DOMAIN = 'privaterelay.appleid.com'

// Do not add any other roles. The customer portal should only contain features
// for customers and employees. Admin features belong into the admin portal.
export const EMPLOYEE_ROLE = 'employee'

export const USER_PUSH_NOTIFICATIONS_DISMISSED_KEY = 'push-notifications-dismissed'
